import { useQuery } from '@tanstack/react-query';
import { broadcastCustomerRestrictionApi } from '../../api';
import { EBroadcastCustomerRestrictionsQueryKey } from '../../model';
import { IBroadcastRestrictionsOptions } from './use-broadcast-restrictions.types';

export const useBroadcastRestrictions = ({ broadcastId = 0 }: IBroadcastRestrictionsOptions) => {
  return useQuery({
    queryKey: [
      broadcastId,
      EBroadcastCustomerRestrictionsQueryKey.BROADCAST_RESTRICTIONS,
    ],
    enabled: !!broadcastId,
    queryFn: () => broadcastCustomerRestrictionApi.getBroadcastCustomerRestriction({
      broadcastId
    })
  });
};
